import { render, staticRenderFns } from "./TagCategories.vue?vue&type=template&id=4860d4ca&scoped=true&"
import script from "./TagCategories.vue?vue&type=script&lang=js&"
export * from "./TagCategories.vue?vue&type=script&lang=js&"
import style0 from "./TagCategories.vue?vue&type=style&index=0&id=4860d4ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860d4ca",
  null
  
)

export default component.exports